import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { seoArticles } from '@/mocks/articles';

export default function BlogSection() {
  const { t } = useTranslation();

  const articles = seoArticles;

  return (
    <section id="blog" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-label font-semibold tracking-widest uppercase text-accent-500 mb-3 block">
            {t('blog_label')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Artigos e Guias
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Conteúdo exclusivo para você dominar as compras internacionais e economizar em cada pedido.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <article
              key={article.slug}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-200 transition-all duration-300 flex flex-col"
            >
              <Link to={`/${article.slug}`} className="block overflow-hidden">
                <div className="aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    title={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </Link>

              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-label text-accent-500 font-semibold tracking-wider uppercase mb-2">
                  {article.category}
                </span>

                <Link to={`/${article.slug}`} className="block mb-3">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 leading-tight group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                </Link>

                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.subtitle}
                </p>

                <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400 font-label flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <Link
                    to={`/${article.slug}`}
                    className="text-xs font-semibold font-label text-primary-500 hover:text-primary-600 flex items-center gap-1 transition-colors duration-200"
                  >
                    Ler artigo
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-label font-semibold text-sm px-7 py-4 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            <span>{t('blog_cta')}</span>
            <span className="w-7 h-7 flex items-center justify-center border border-background-50/40 rounded-full transition-transform duration-200 group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}